import {Component, computed, Injectable, Input, signal} from '@angular/core';
import {MatCheckboxChange, MatCheckboxModule} from '@angular/material/checkbox';
import {ResourceSearchSchema, ResourceTypes} from '@middleware';
import {Filter, FilterVisibility} from '../filter';

const valid_values = {generic: 'Resource', past_event: 'Past Event', future_event: 'Future Event'};

@Component({
  template: `<ul class="bulletless">
    @for (v of valid_keys; track v) {
      <li
        ><mat-checkbox [value]="v" [checked]="filter.selectedValues().includes(v)" (change)="changeSelection($event)"
          >{{ valid_values[v] }}s</mat-checkbox
        ></li
      >
    }
  </ul>`,
  imports: [MatCheckboxModule],
})
class TypePicker {
  constructor() {}
  @Input() filter: TypeFilter;

  valid_values = valid_values;
  valid_keys = Object.keys(valid_values);

  changeSelection($event: MatCheckboxChange) {
    if ($event.checked) {
      this.filter.selectedValues.update(values => [...values, $event.source.value]);
    } else {
      this.filter.remove($event.source.value);
    }
  }
}

@Injectable()
export class TypeFilter implements Filter<'Resources'> {
  key = 'resource_type' as const;
  label = 'Type';
  component = TypePicker;
  selectedValues = signal<string[]>([]);
  selected = computed(() => this.selectedValues().map(value => ({label: valid_values[value], value})));
  defaultExpanded = false;
  load(values: string[]) {
    this.selectedValues.set(values.filter(v => Object.keys(valid_values).includes(v)));
  }
  apply(filterBody: ResourceSearchSchema) {
    const selected = this.selectedValues();
    if (selected.length == 0) return;

    filterBody.resource_type = {
      match_all: false,
      terms: [],
    };

    const now = new Date();
    const past = selected.includes('past_event'),
      future = selected.includes('future_event');

    if (selected.includes('generic')) {
      (<ResourceTypes[]>filterBody.resource_type.terms).push(<ResourceTypes>'Generic');
    }

    if (past || future) {
      (<ResourceTypes[]>filterBody.resource_type.terms).push(<ResourceTypes>'Event');

      // If both are selected, we don't need a time filter as we want all events
      if (past && future) return;

      filterBody.ends = {};

      if (past) {
        // Events that ended before now
        filterBody.ends.end = now.toISOString();
      }
      if (future) {
        // Events ending on or after the current time
        filterBody.ends.start = now.toISOString();
      }
    }
  }
  remove(value: string) {
    this.selectedValues.update(values => values.filter(v => v != value));
  }
  visibility = FilterVisibility.EVERYONE;
}
